import { getBuyButtonConfig } from '../utils/commonEntitlements';

export const CORP_FORMATION_CONFIG = {
  hero: {
    buyBox: [
      {
        bulletPoints: [
          { title: 'productPage.corpFormation.buyBox.bulletPoint1' },
          { title: 'productPage.corpFormation.buyBox.bulletPoint2' },
          { title: 'productPage.corpFormation.buyBox.bulletPoint3' },
        ],
        productName: 'productPage.corpFormation.buyBox.productName',
        interactService: {
          service: 'corp_formation',
        },
      },
    ],
    headerPicture: {
      src: '/s2/raster/business-chat-partners.png',
      alt: 'productPage.corpFormation.heroPicture.altText',
    },
    headline: 'productPage.corpFormation.page.headline',
    partnerLogo: {},
    partnerReviewBlanks: [],
    subheader: 'productPage.corpFormation.page.subheader',
  },
  benefit: {
    title: 'productPage.corpFormation.valueProp.title',
    items: [
      {
        icon: '/s2/material-icons/addcircleoutlinerounded.svg',
        title: 'productPage.corpFormation.valueProp.propTitle1',
        description: 'productPage.corpFormation.valueProp.shortCopy1',
      },
      {
        icon: '/s2/material-icons/groupsrounded.svg',
        title: 'productPage.corpFormation.valueProp.propTitle2',
        description: 'productPage.corpFormation.valueProp.shortCopy2',
      },
      {
        icon: '/s2/material-icons/rotaterightrounded.svg',
        title: 'productPage.corpFormation.valueProp.propTitle3',
        description: 'productPage.corpFormation.valueProp.shortCopy3',
      },
    ],
  },
  highlight: {
    icon: '/s2/material-icons/helpoutlinerounded.svg',
    title: 'productPage.corpFormation.topFeature.title',
    subheader: 'productPage.corpFormation.topFeature.subheader',
    image: '/s2/raster/office-review-meeting-colleagues.png',
    alt: 'productPage.corpFormation.topFeature.altText',
  },
  howItWorks: {
    title: 'productPage.corpFormation.howItWorks.title',
    items: [
      {
        title: 'productPage.corpFormation.howItWorks.step1',
        description: 'productPage.corpFormation.howItWorks.shortDescription1',
      },
      {
        title: 'productPage.corpFormation.howItWorks.step2',
        description: 'productPage.corpFormation.howItWorks.shortDescription2',
      },
      {
        title: 'productPage.corpFormation.howItWorks.step3',
        description: 'productPage.corpFormation.howItWorks.shortDescription3',
      },
      {
        title: 'productPage.corpFormation.howItWorks.step4',
        description: 'productPage.corpFormation.howItWorks.shortDescription4',
      },
    ],
    image: '/s2/raster/creative-team-review-office.png',
    alt: 'productPage.corpFormation.howItWorks.altText',
    hasNumber: true,
    hasDivider: false,
    hasMobileImage: true,
  },
  faqs: {
    title: 'productPage.corpFormation.frequentlyAskedQuestions.title',
    items: [
      {
        question: 'productPage.corpFormation.frequentlyAskedQuestions.faq1',
        answer: 'productPage.corpFormation.frequentlyAskedQuestions.faqAnswer1',
      },
      {
        question: 'productPage.corpFormation.frequentlyAskedQuestions.faq2',
        answer: 'productPage.corpFormation.frequentlyAskedQuestions.faqAnswer2',
      },
      {
        question: 'productPage.corpFormation.frequentlyAskedQuestions.faq3',
        answer: 'productPage.corpFormation.frequentlyAskedQuestions.faqAnswer3',
      },
    ],
  },
  assistance: {
    title: 'productPage.corpFormation.needAssistance.title',
    getInTouch: 'productPage.corpFormation.needAssistance.getInTouch',
    actions: 'productPage.corpFormation.needAssistance.actions',
  },
  getBuyButtonConfig: (entitlements, service) =>
    getBuyButtonConfig({
      entitlements,
      service,
      ctaText: 'productPage.corpFormation.buyBox.buttonLabel',
    }),
};
